import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ConstantsService } from '../constants.service';

@Injectable({
	providedIn: 'root'
})
export class ContingencyMasterTableService {

	constructor(private readonly http : HttpClient, private readonly constantsService : ConstantsService) { }
	loadDataContingencyMasterPCS(periodId): Observable<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/giContingencyM/getPCSDate/${periodId}`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError));
	}

	loadDataContingencyLLT(periodId): Observable<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/giContingencyM/getContingency/${periodId}`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError));
	}

	addPCSDate(periodId, contprodDate, doubleshipDate) {
		const InData  = {
			contprodDate: contprodDate,
			doubleshipDate: doubleshipDate,
			periodID: periodId
		}
		return this.http.post(`${this.constantsService.baseAPIURL}/giContingencyM/addPCSDate`, InData, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}
	deleteMasterPCSRecord(pcsdateID): Observable<any> {
		return this.http
			.delete(`${this.constantsService.baseAPIURL}/giContingencyM/deletePCSDate?pcsdateID=${pcsdateID}`, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}

	uploadExcelFileLLTData(excelFile: File,periodID,userId): Observable<any> {
		const formData: FormData = new FormData();
		formData.append('file', excelFile, excelFile.name)
		return this.http.post(`${this.constantsService.baseAPIURL}/validatePCSContingency/${periodID}/${userId}`, formData, { responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}
	private handleError(error: HttpErrorResponse): Observable<never> {
		return throwError(() => error.message || 'Server Error');
	}

}